module.exports = __webpack_public_path__ + "img/1998.d1280a6e.png";